import * as React from 'react';
import { useSelector } from 'react-redux';

import { Container } from '../../components/Container';
import { Section } from '../../components/Section';
import { selectIsRedesign } from '../../selectors/isRedesign';
import { isSearchOffersExperimentEnabled } from '../../utils/searchOffersExperiment';
import { AddOfferButtonContainer } from '../AddOfferButtonContainer';
import { useApplicationContext } from '../ApplicationContext';
import { GeoLocationModalContainer } from '../GeoLocationModalContainer';
import { MobileBannerContainer } from '../MobileBannerContainer';
import { ConditionalOffersContainer } from '../OffersContainer';
import { PikPromoBannerContainer } from '../PikPromoBannerContainer';
import { QuickFiltersContainer } from '../QuickFiltersContainer';
import { QuickLinksContainer } from '../QuickLinksContainer';
import { RecommendationsContainer } from '../RecommendationsContainer';
import { RegionSelectCallContainer } from '../RegionSelectCallContainer';
import { SearchBlockContainer } from '../SearchBlockContainer';
import { SeoDescriptionContainer } from '../SeoDescriptionContainer';
import { SeoRegionsContainer } from '../SeoRegionsContainer';
import { ServicesContainer } from '../ServicesContainer';

export const Page: React.FC = () => {
  const context = useApplicationContext();
  const isRedesign = useSelector(selectIsRedesign);
  const searchOffersExperimentEnabled = isSearchOffersExperimentEnabled(context);

  return (
    <Container>
      <MobileBannerContainer />

      {searchOffersExperimentEnabled && <SearchBlockContainer />}
      {searchOffersExperimentEnabled && <ConditionalOffersContainer />}

      <Section marginTop={16}>
        <QuickFiltersContainer />
      </Section>

      {!isRedesign && (
        <Section marginTop={32}>
          <AddOfferButtonContainer />
        </Section>
      )}

      <Section marginTop={32}>
        <ServicesContainer />
      </Section>

      <Section marginTop={32}>
        <RecommendationsContainer />
      </Section>

      <PikPromoBannerContainer />

      <QuickLinksContainer />

      <SeoRegionsContainer />

      <SeoDescriptionContainer />

      <RegionSelectCallContainer />

      <GeoLocationModalContainer />
    </Container>
  );
};
